import { ngModuleRegistrar } from '../../helpers';
import {
    autoExpand,
    ignoreMouseWheel,
    insertTag,
    limitToMax,
    lowerThan,
    multiselectRequired,
    notGreaterThan,
    notLessThan,
    numberMax,
    numberMin,
    onlyInteger,
    onlyText,
    pageLoader,
    responsiveTabs,
    rtl,
    scrollable,
    scopeId,
    checkDigitAlgorithm,
    hoverOnHorizontalScroll,
    numberMaxLength,
    notZero,
    notZeroDays,
    greaterThan,
    atLeastNgDropdown,
    multiplyEmailsValidate,
    bidiNumber,
    trimStartZero,
    maxSmsValue,
    validateEmails,
    checkToChange,
} from './index';

export default ngModuleRegistrar('directive', {
    pageLoader,
    rtl,
    lowerThan,
    numberMax,
    numberMin,
    ignoreMouseWheel,
    scrollable,
    limitToMax,
    notGreaterThan,
    notLessThan,
    autoExpand,
    insertTag,
    responsiveTabs,
    onlyText,
    onlyInteger,
    multiselectRequired,
    scopeId,
    checkDigitAlgorithm,
    hoverOnHorizontalScroll,
    numberMaxLength,
    notZero,
    notZeroDays,
    greaterThan,
    atLeastNgDropdown,
    multiplyEmailsValidate,
    bidiNumber,
    trimStartZero,
    maxSmsValue,
    validateEmails,
    checkToChange,
});



// WEBPACK FOOTER //
// ./src/ui/directives/register.js